export enum MoMRouteNames {
  MOM_HOME = 'MoM/Home',
  WITH_EMAIL = 'WithEmail',
  LOGIN_WITH_EMAIL = 'LoginWithEmail',
  SHIFT_SCHEDULER = 'ShiftScheduler/Home',
  SHIFT_POOL_HOME = 'ShiftPool/Home',
  TASK_MANAGER = 'TaskManager/Home',
  MORE = 'more',
  AVAILABILITY_HOME = 'Availability/Home',
  AVAILABILITY_EMPLOYEE = 'Availability/EmployeesAvailability',
  TIME_OFF_HOME = 'TimeOff/Home',
  TIME_OFF_DETAILS = 'TimeOff/TimeOffDetails',
  CAMPAIGNS = 'Campaigns/Home',
  CAMPAIGNS_DETAIL = 'Campaigns/CampaignDetail',

  DOC_VAULT = 'DocVault/Home',
  DOC_VAULT_FOLDER = 'DocVault/FolderDetails',
  DOC_VAULT_CATEGORY = 'DocVault/CategoryDetails',
  CHAT = 'Chat/Home',
  AUTO_CLOSE_OUT_DETAILS = 'TimeCardNavigation/TimeCard',
  PREP_LIST = 'PreparePrepListNavigation/PrepList',
}
